import React from 'react';

export const ProfileSidebar = ({ selectedChat, isMobileOverlay, onlineUsers = [] }) => {
  if (!selectedChat) return null;

  const participant = selectedChat.participant || {};
  const displayName = `${participant.firstName || ''} ${participant.lastName || ''}`.trim() || 'Unknown';
  const initials = displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  const isOnline = participant._id && onlineUsers.some(id => id.toString() === participant._id.toString());

  const content = (
    <div className="text-center">
      <div className="relative inline-block mb-3 sm:mb-4">
        <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl bg-gradient-to-br from-blue-500 to-blue-700 mx-auto flex items-center justify-center text-white font-bold text-2xl sm:text-3xl overflow-hidden">
          {participant.profileImage ? (
            <img src={participant.profileImage} alt={displayName} className="w-full h-full object-cover" />
          ) : (
            initials
          )}
        </div>
        <div className={`absolute top-0 right-0 w-3 h-3 sm:w-4 sm:h-4 ${isOnline ? 'bg-green-500' : 'bg-gray-500'} rounded-full border-2 border-jp-card`}></div>
      </div>

      <h3 className="text-jp-ink font-bold text-base sm:text-lg mb-1">{displayName}</h3>
      <p className={`text-xs sm:text-sm mb-1 font-medium ${isOnline ? 'text-green-400' : 'text-jp-muted'}`}>
        {isOnline ? 'Online' : 'Offline'}
      </p>
      <p className="text-jp-muted text-xs sm:text-sm mb-3 sm:mb-4">
        {participant.role ? participant.role.charAt(0).toUpperCase() + participant.role.slice(1) : ''}
      </p>

      {/* <button className="w-full px-4 py-2 sm:py-2.5 bg-jp-section hover:bg-jp-line border border-jp-line rounded-lg text-jp-ink text-sm sm:text-base font-medium transition-colors">
        VIEW PROFILE
      </button> */}
    </div>
  );

  if (isMobileOverlay) {
    return <div className="p-4 sm:p-6">{content}</div>;
  }

  return (
    <div className="hidden lg:block w-64 xl:w-80 bg-jp-card border-l border-jp-line p-4 sm:p-6">
      {content}
    </div>
  );
};
